import React from 'react';
import DropOffDesktop from './DropOffDesktop';
import DropOffMobile from './DropOffMobile';

const DropOff = () => {
  return (
    <div>
      <div className={`hidden lg:flex flex-col`}>
        <DropOffDesktop />
      </div>
      <div className={`flex lg:hidden`}>
        <DropOffMobile />
      </div>
    </div>
  );
};

export default DropOff;
